import { Link } from "react-router-dom";
import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import Logo from "@/components/Logo";

export default function Footer() {
  const [email, setEmail] = useState("");
  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    try { await api.post("/enquiries", { type: "newsletter", data: { email } }); toast.success("Subscribed! Welcome to KRVMart."); setEmail(""); }
    catch { toast.error("Could not subscribe, try again."); }
  };

  const col = (title, links) => (
    <div>
      <h4 className="mb-4 text-sm font-bold uppercase tracking-wide text-white">{title}</h4>
      <ul className="space-y-2.5">
        {links.map(([label, to]) => (
          <li key={label}><Link to={to} className="text-sm text-white/60 hover:text-gold transition-colors">{label}</Link></li>
        ))}
      </ul>
    </div>
  );

  return (
    <footer className="bg-midnight text-white">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8 py-16">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-6">
          <div className="lg:col-span-2">
            <Logo className="h-9 w-auto" />
            <p className="mt-3 text-sm text-white/60 max-w-xs">Everything for Everyday Living. A modern multi-category retail destination bringing Home, Style, Furniture and Technology together.</p>
            <form onSubmit={subscribe} className="mt-6 flex max-w-sm gap-2">
              <input data-testid="newsletter-email" value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="Your email for updates" className="flex-1 rounded-full bg-white/10 px-4 py-2.5 text-sm outline-none placeholder:text-white/40 focus:bg-white/15" />
              <button data-testid="newsletter-subscribe" className="rounded-full bg-gold px-5 py-2.5 text-sm font-semibold text-midnight hover:bg-gold-soft transition-colors">Subscribe</button>
            </form>
          </div>
          {col("Shop", [["Home Mart", "/home-mart"], ["Style Mart", "/style-mart"], ["Wood Mart", "/wood-mart"], ["Tech Mart", "/tech-mart"], ["Offers", "/offers"], ["New Arrivals", "/new-arrivals"]])}
          {col("Company", [["About", "/about"], ["Stores", "/stores"], ["Vendor With Us", "/become-vendor"], ["Franchise", "/franchise"], ["Corporate", "/corporate"], ["Contact", "/contact"]])}
          {col("Customer Care", [["Track Order", "/account/orders"], ["Shipping Policy", "/legal/shipping-policy"], ["Returns & Refunds", "/legal/returns-refunds"], ["Warranty Policy", "/legal/warranty-policy"], ["Support", "/contact"], ["Journal", "/blog"]])}
          {col("Legal", [["Privacy Policy", "/legal/privacy-policy"], ["Terms & Conditions", "/legal/terms"], ["Shipping Policy", "/legal/shipping-policy"], ["Cancellation Policy", "/legal/cancellation-policy"], ["Disclaimer", "/legal/disclaimer"]])}
        </div>
        <div className="mt-14 border-t border-white/10 pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-center">
          <p className="text-xs text-white/50">KRVMart is a retail brand of KRV Nexus Pvt Ltd. <span className="text-gold/80">KRV Nexus — Where Vision Becomes Value.</span></p>
          <p className="text-xs text-white/50">© 2026 KRV Nexus Pvt Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
